import {
  ActionProcessMode,
  IContextMenuItemRefreshRules,
} from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { RefreshStrategy } from '../wrap/CategoryCommand';

import CategoryCommandImpl from './CategoryCommandImpl';
import RunActionCommandImpl from './RunActionCommandImpl';

class DeleteRecordCommandImpl extends CategoryCommandImpl<void> {
  constructor(private runActionCommand: RunActionCommandImpl) {
    super();
  }

  public execute(context: ClientContext): Promise<void | Record<string, any>> {
    return this.runActionCommand.execute(context, {});
  }

  public async getInitialArgs(): Promise<void> {
    // not implemented
  }

  public getName(): CommandName {
    return this.runActionCommand.getName();
  }

  public getProcessMode(): ActionProcessMode {
    return 'Sequential';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.REMOVE;
  }

  public getRefreshRules(): IContextMenuItemRefreshRules | undefined {
    return this.runActionCommand.getRefreshRules();
  }
}

export default DeleteRecordCommandImpl;
